/* Selectors */
import isEmpty from 'lodash/isEmpty';
import toString from 'lodash/toString';
import { createSelector } from "reselect";

export const getEventsFetchingState = state => state.events.isFetchingEvents;
export const getEventListPageLoading = state => state.events.isLoadingEventListPage;
export const getBookingsPageLoading = state => state.events.isLoadingBookingsPage;
export const getBookingsFetchingState = state => state.events.isFetchingBookings;
export const getEvents = state => state.events.list;
export const getSelectedEvent = state => state.events.event;
export const getSelectedEventLoadedState = state => !isEmpty(state.events.event);
export const getSelectedEventIdFromEvent = state => state.events.event._id;
export const getSelectedEventId = state => state.events.eventid;
export const getEventsCount = state => state.events.listCount;
export const getCurrentEventPage = state => state.events.currentEventPage;
export const getLoadingState = state => state.events.isLoading;
export const getBookings = state => state.events.bookings;
export const getBookingsCount = state => state.events.bookingsCount;
export const getCurrentBookingPage = state => state.events.currentBookingPage;
export const getVenueRejectingState = state => state.events.isRejectingVenue;
export const getEventPlanningState = state => state.events.isPlanningEvent;

//common module
export const getBundle = state => state.events.bundle;
export const getOccasions = state => state.events.occasions;
export const getCities = state => state.events.cities;
export const getPackages = state => state.events.packages;
export const getVenuetypes = state => state.events.venuetypes;
export const getLocations = state => state.events.locations;
export const getEventAssets = state => state.events.assets;
export const getVenueTourLoaderState = state => state.events.venueTourLoader

//detailsPage
export const getSavingEventInfo = state => state.events.isSavingEventInfo;
export const getDetailsPageParamState = state => state.events.isLoadingBaseParams || state.events.isLoadingLocationParams;
export const getVenueRecoCount = state => state.events.recoVenueCount;

// reco page
export const getRecoListCombinedV1 = state => state.events.recoListCombinedV1;
export const getRecoListCombinedV2 = state => state.events.recoListCombinedV2;
export const getRecoPageLoadingState = state => state.events.isLoadingRecoPage;
export const getBundleFetchingState = state => state.events.isFetchingBundle;
export const getRecommendedPageState = state => state.events.isFetchingEvent || state.events.isFetchingBundle || state.events.isLoadingBaseParams || state.events.isLoadingLocationParams;
export const getRecommendedOptions = state => state.events.venues;
export const getSelectedEventVerifiedState = state => !!state.events.event.isVerified;
export const getRecommendedList = state => isEmpty(state.events.bundle) ? [] : state.events.bundle.recoList;
export const getLoadingVenueList = state => state.events.isLoadingVenueList;

//shortlistedPage
export const getIsSavingVisit = (state) => state.events.isSavingVisit;
export const getShortlistedPageState = state => state.events.isFetchingEvent || state.events.isFetchingBundle;
export const getMagicToken = state => state.events.event && state.events.event.magicToken ? state.events.event.magicToken : "";

export const getShortlistedVenueList = state => {
    let bundle = getBundle(state);
    return !isEmpty(bundle) && bundle.venueList ? bundle.venueList.filter(({ userReject, userShow }) => !userReject && userShow) : []
}

export const getShortlistedVenuesForUser = state => {
  return !isEmpty(state.events.bundle) && state.events.bundle.venueList ?
    state.events.bundle.venueList.filter(({ userReject, userShow }) => !userReject && userShow) : [];
};

export const getShortlistedVenueListIds = createSelector(
  getBundle,
  bundle => !isEmpty(bundle) && bundle.venueList ? bundle.venueList.filter(({ userReject, userShow }) => !userReject && userShow)
    .map((item)=>{
    if(typeof item.uid =="object"){
      return item.uid._id.toString()
    }
    else{
      return item.uid.toString()
      
    }

    }) : [],

);

export const getShortlistedVisitsList = createSelector(
  getBundle,
  bundle => !isEmpty(bundle) && bundle.venueList ? bundle.venueList.filter(({ visit_confirm }) => visit_confirm) : [],
);
export const getShortlistedPackSentList = createSelector(
  getBundle,
  bundle => !isEmpty(bundle) && bundle.prevemails ? bundle.prevemails : [],
);

export const getVisitPlanningState = state => state.events.isCreatingVisit;
export const getEventBroadcastedToAgentStatus = state => state.events.isEventBroadcastedToAgent;
export const getIsPlanVisitSuccess = state => state.events.isPlanVisitSuccess;

export const getVisitsPageState = state => state.events.isFetchingEvent || state.events.isFetchingBundle;

//bookingPage
export const getBookingPageState = state => state.events.isFetchingEvent || state.events.isFetchingBundle;
export const getConfirmingBooking = state => state.events.isConfirmingBooking;
export const getIsBookingRequestSent = state => state.events.isBookingRequestSent;

export const getBookedVenue = createSelector(
  [getBundle, getSelectedEvent],
  (bundle, event) => !isEmpty(bundle) && bundle.venueList && !isEmpty(event) && event.finalVenueId ? bundle.venueList.filter((item) => toString(item.uid._id) === toString(event.finalVenueId))[0] : {},
);
//customer feedback page
export const getEventFeedback = state => state.events.feedback;
export const getSavingState = state => state.events.isSaving;
// Plan Event and Request Booking
export const getRequestBookingModal = state => state.events.isRequestBookingOverlayOpen;
export const getRequestBookingSuccessModal = state => state.events.isRequestBookingSuccessOverlayOpen;
export const getPlanVisitModal = state => state.events.isPlanVisitOverlayOpen;
export const getVisitData = state => state.events.visitUpdatedata;
export const getPlanVisitSuccessModal = state => state.events.isPlanVisitSuccessOverlayOpen;
export const getPlanVisitEditModal = state => state.events.isPlanVisitEditOverlayOpen;
export const getShortlistedVenue = state => state.events.venueShortlisted;
export const getHeavyDate = state => state.events.heavyDate;
export const getBookingVisitcountVisibleState = state => state.events.isBookingvisitcount;
export const getScheduleCallModalState = state => state.events.is_schedule_call_modal_visible;
export const getEventsCountBasedOnCategory = state => state.events.eventsCount
export const getVisitDetails = state => state.events.visitDetails

export const getMonthlyWinners = state => state.events.monthlywinners

export const getMonthlyLeaderBoardData = state => state.events.monthlyleaderboarddata

export const getReviewTickets = state => state.events.tickets
export const getleaderboardloadingstate = state => state.events.leaderdataloading
export const getticketsloadingstate = state => state.events.ticketsloading




